/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { InvoiceSettingsShowPathParams, InvoiceSettingsShowResponse } from '../types/InvoiceSettingsShow'

/**
 * GET /:organisation/invoice-settings
 * @see backend/nexus/modules/Billing/Http/Controllers/InvoiceSettingsController.php InvoiceSettingsController::show
 */
export async function invoiceSettingsShow(
	organisation: InvoiceSettingsShowPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InvoiceSettingsShowResponse>> {
	return axiosInstance.get(`/${organisation}/invoice-settings`, config)
}
